import { useState } from "react";
import investnow from "../../assets/invest-now.png";

export default function InvestCredits() {
   const [open, setOpen] = useState(false);

   const handleContinue = () => {
      window.open(
         "https://www.interactivebrokers.com/en/index.php?f=account_opening",
         "_blank",
         "noopener,noreferrer"
      );
      setOpen(false);
   };

   return (
      <>
         {/* PAGE WRAPPER — VERTICAL CENTER */}
         <div className="w-full min-h-[calc(100vh-5rem)] flex items-center">
            <div className="bg-white max-w-2xl mx-auto rounded-2xl shadow-lg p-4 sm:p-6">
               {/* Image */}
               <div className="flex justify-center mb-3">
                  <img
                     src={investnow}
                     alt="Investment Disclaimer"
                     className="w-full max-w-[220px] object-contain"
                  />
               </div>

               {/* Text */}
               <div className="text-gray-700 text-xs sm:text-sm text-center space-y-2">
                  <p>
                     <strong>FareFuel</strong> is not a broker-dealer, investment advisor,
                     financial institution, or custodian and does not provide investment,
                     legal, or tax advice.
                  </p>
               </div>

               {/* Button */}
               <div className="mt-4 flex justify-center">
                  <button
                     onClick={() => setOpen(true)}
                     className="bg-green-700 hover:bg-green-600 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition shadow"
                  >
                     Create an Interactive Brokers Account
                  </button>
               </div>
            </div>
         </div>

         {/* MODAL */}
         {open && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
               <div className="bg-white w-full max-w-xl rounded-xl shadow-xl p-5">
                  <h2 className="text-lg font-semibold text-gray-900 mb-3">
                     Investment & Brokerage Disclaimer
                  </h2>

                  <div className="text-xs sm:text-sm text-gray-700 space-y-2">
                     <p>
                        FareFuel is not a broker-dealer, investment advisor, financial
                        institution, or custodian and does not provide investment, legal,
                        or tax advice.
                     </p>

                     <p className="font-medium">FareFuel does not:</p>
                     <ul className="list-disc pl-5 space-y-1">
                        <li>Open or manage brokerage accounts</li>
                        <li>Hold, transfer, or invest customer funds</li>
                        <li>Execute trades or investment transactions</li>
                        <li>
                           Access or view brokerage balances, portfolios, or trading activity
                        </li>
                     </ul>

                     <p>
                        Any investment activity is conducted solely between you and
                        Interactive Brokers (IBKR).
                     </p>

                     <p>
                        By continuing, you acknowledge that FareFuel’s role is limited to
                        providing informational links and referrals only.
                     </p>
                  </div>

                  <div className="mt-4 flex justify-end gap-3">
                     <button
                        onClick={() => setOpen(false)}
                        className="px-4 py-2 rounded-full border text-xs sm:text-sm text-gray-600 hover:bg-gray-100"
                     >
                        Cancel
                     </button>

                     <button
                        onClick={handleContinue}
                        className="px-4 py-2 rounded-full bg-green-700 hover:bg-green-500 text-white text-xs sm:text-sm font-semibold"
                     >
                        I Understand & Continue
                     </button>
                  </div>
               </div>
            </div>
         )}
      </>
   );
}
